"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const NavigationLink_1 = __importDefault(require("./NavigationLink"));
exports.default = NavigationLink_1.default;
